import { render } from "./CodeEnvironment.vue?vue&type=template&id=e63bbf78"
import script from "./CodeEnvironment.vue?vue&type=script&lang=js"
export * from "./CodeEnvironment.vue?vue&type=script&lang=js"

import "./CodeEnvironment.vue?vue&type=style&index=0&id=e63bbf78&lang=css"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
